/**
 * Detecta nova release via /version.json e recarrega a página.
 * O index/bundles com hash já mudam no build; isto cobre quem ficou
 * com aba aberta ou HTML antigo em cache sem Docker/nginx.
 */
const CHECK_INTERVAL_MS = 5 * 60 * 1000;

export function getBuildVersion() {
  return process.env.VUE_APP_VERSION || "";
}

export async function fetchRemoteVersion() {
  const response = await fetch(`/version.json?_=${Date.now()}`, {
    cache: "no-store",
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });
  if (!response.ok) {
    throw new Error(`version.json HTTP ${response.status}`);
  }
  return response.json();
}

export async function checkAppVersionAndReload() {
  const localVersion = getBuildVersion();
  if (!localVersion) {
    return false;
  }

  try {
    const remote = await fetchRemoteVersion();
    if (remote && remote.version && remote.version !== localVersion) {
      // Evita loop se o reload acontecer antes do novo HTML estar disponível
      const key = "app-version-reload";
      const last = sessionStorage.getItem(key);
      if (last === remote.version) {
        return false;
      }
      sessionStorage.setItem(key, remote.version);
      window.location.reload();
      return true;
    }
  } catch (e) {
    // silencioso: ambiente local sem version.json ou rede offline
  }
  return false;
}

export function startAppVersionWatcher() {
  checkAppVersionAndReload();

  const onVisible = () => {
    if (document.visibilityState === "visible") {
      checkAppVersionAndReload();
    }
  };

  document.addEventListener("visibilitychange", onVisible);
  window.addEventListener("focus", checkAppVersionAndReload);

  const timer = setInterval(checkAppVersionAndReload, CHECK_INTERVAL_MS);

  return () => {
    document.removeEventListener("visibilitychange", onVisible);
    window.removeEventListener("focus", checkAppVersionAndReload);
    clearInterval(timer);
  };
}
